import { useEffect, useRef } from 'react'
import { isApiConfigured } from '@/config/api/env'
import { fetchThreads } from '@/services/chat/threadsApi'
import { applyFetchedThreads } from './backendChatSyncState'

export function useBackendThreadListSync(m, accessToken) {
  const {
    activePrimaryKey,
    displayThreadId,
    selectedThreadId,
    setSelectedThreadId,
    setThreads,
    urlThreadId,
  } = m
  const didSelectInitialServerThread = useRef(false)

  useEffect(() => {
    if (!accessToken || !isApiConfigured() || activePrimaryKey !== 'home') return
    const controller = new AbortController()
    void fetchThreads({ signal: controller.signal })
      .then((threads) => applyFetchedThreads(threads, {
        didSelectInitialServerThread,
        displayThreadId,
        selectedThreadId,
        setSelectedThreadId,
        setThreads,
        urlThreadId,
      }))
      .catch(() => {})
    return () => controller.abort()
  }, [
    accessToken,
    activePrimaryKey,
    displayThreadId,
    selectedThreadId,
    setSelectedThreadId,
    setThreads,
    urlThreadId,
  ])
}
